import axios from "axios";
import useInterval from "@use-it/interval";
import React, { useReducer, createContext, useEffect } from "react";
import VersionReducer from "./versionReducer";
import { VersionState } from "./versionState";
import { Actions } from "./versionActions";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CreateProviderValue = (props) => {
  const [state, dispatch] = useReducer(VersionReducer, VersionState);
  const dismissVersionNotifier = () => {
    dispatch({
      type: Actions.DISMISS,
    });
  };

  const fetchVersion = async () => {
    try {
      const response = await axios.get<{ version: string }>("/version.json");
      // If this point is reached, API succeeded with no error
      // set the first time loading to false
      dispatch({
        type: Actions.SET_FIRST_TIME_LOADING,
        payload: false,
      });
      if (!state.currentVersion) {
        dispatch({
          type: Actions.SET_INITIAL_VERSION,
          payload: { version: response.data.version },
        });
        return;
      }
      if (state.currentVersion === response.data.version) {
        // Versions are synched so has new version is false
        dispatch({
          type: Actions.SET_HAS_NEW_VERSION,
          payload: false,
        });
        return;
      }
      // Versions are not synced
      dispatch({
        type: Actions.SET_VERSION,
        payload: { version: response.data.version },
      });
      dispatch({
        type: Actions.SET_HAS_NEW_VERSION,
        payload: true,
      });
    } catch (err) {
      // Do nothing: network error so the next fetch will handle
    }
  };

  return {
    ...state,
    fetchVersion,
    dismissVersionNotifier,
  };
};

export type VersionProviderValue = ReturnType<typeof CreateProviderValue>;
export const VersionContext = createContext({} as VersionProviderValue);

const VersionProvider: React.FC = (props) => {
  const intervalCheckInMS = 1000 * 60;
  const providerValue = CreateProviderValue(props);

  useInterval(() => {
    providerValue.fetchVersion();
  }, intervalCheckInMS);

  useEffect(() => {
    providerValue.fetchVersion();
  }, []);

  return <VersionContext.Provider value={providerValue}>{props.children}</VersionContext.Provider>;
};

export default VersionProvider;
